/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import { Close } from "@mui/icons-material"
import { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { LocalStorage } from "src/framework/commons/LocalStorage"
import { apiNoLoading } from "src/framework/providers/api"
import { useObservable } from "src/framework/store/storeUtil"
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types"
import { CacheType, contaUsuario$, distribuidoresPorTipoDeConta$, getDistribuidores, getDistribuidoresPorTipoDeConta } from "src/store/global.store"
import { FilterProps, INITIAL_FILTERS_STATE } from "../../Cards"
import { EXPIRADO_LIST, KITS_LIST, SEGMENTO_LIST, SITUACAO_PAGAMENTOS_LIST, ORIGEM_LIST, PROJETO_MIGRADO, PROJETO_FINAME, TIPO_PROJETO, ETAPAS_LIST } from "../../constants"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { debounce } from "lodash"
import { ContaUsuario } from "src/store/global.store.types"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { InputComboBox } from "src/framework/components/forms/inputs/InputComboBox"
import { InputText } from "src/framework/components/forms/inputs/InputText"

interface FilterDrawerProps {
  isOpened: boolean;
  close: () => void;
  filters: FilterProps
  setFilters: (filters: any) => void
  handleSearch: () => void
}

const initLoad = async (): Promise<void> => {
  await getDistribuidores();
  await getDistribuidoresPorTipoDeConta();
}

const getFilteredOptionsByNomeOrDoc = (options: any[], searchText: string) => {
  if (!searchText) return options;
  const normalizedSearch = (searchText).replace(/[^a-zA-Z0-9]/g, '')
  if (normalizedSearch && normalizedSearch.length !== 14) {
      return options.filter((item: { cnpj_cpf: string; nome: string }) => item.nome.toLowerCase().includes(searchText.toLowerCase()))
  }
  return options.filter((item: { cnpj_cpf: string; nome: string }) => {
    const normalizedDoc = (item.cnpj_cpf || '').replace(/[^a-zA-Z0-9]/g, '')
    return (
      (normalizedSearch && normalizedDoc.includes(normalizedSearch))
      || item.nome.toLowerCase().includes(searchText.toLowerCase())
    )
  });
}

const FilterDrawer = ({ isOpened, close, filters, setFilters, handleSearch }: FilterDrawerProps) => {
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
  const [searchRevendas, setSearchRevendas] = useState('')
  const [revendasOptions, setRevendasOptions] = useState([])
  const [revendasIsLoading, setRevendasIsLoading] = useState(false)

  const [distribuidorState, setDistribuidorState] = useState<any>(null);
  const distribuidorListState = useObservable(distribuidoresPorTipoDeConta$);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<ExtraInfoUsuario | null>(null);
  const permissoes = PermissionUtil.getPermissions();

  const isAdmin = useMemo(() => {
    return PermissionUtil.isAdministrador(permissoes)
  }, [permissoes])

  const cbRef = useRef<any>(null)
  const eventSubmit = useCallback((e: any)=>{
    const cb = (e: any) => cbRef.current(e)
    if (e.keyCode === 13) cb(e)
  },[])

  const distribuidoresList = useMemo(()=>{
    if ((distribuidorRevendaUsuario?.isDistribuidor || distribuidorRevendaUsuario?.isRevenda) && distribuidorListState?.data.length) {
      if (distribuidorRevendaUsuario?.distribuidor_id) {
        return distribuidorListState?.data.filter((distribuidor: any) => distribuidor.id === distribuidorRevendaUsuario.distribuidor_id)
      }
    }

    return distribuidorListState?.data || []
  },[distribuidorListState, distribuidorRevendaUsuario])

  useEffect(() => {
    if (distribuidorRevendaUsuario?.isDistribuidor || distribuidorRevendaUsuario?.isRevenda) {
        if (distribuidorRevendaUsuario?.distribuidor_id !== null) {
            const distribuidor = distribuidorListState?.data?.find((f: any) => f.id === distribuidorRevendaUsuario?.distribuidor_id)
            if (distribuidor) {
                setDistribuidorState(distribuidor);
            }
        }
    }
}, [distribuidorRevendaUsuario, distribuidorListState?.data]);

  useEffect(()=>{
    if (isOpened) {
      initLoad();
      const distribuidorRevenda = LocalStorage.get("solar.userExtraInfo", true)
      setDistribuidorRevendaUsuario(distribuidorRevenda)
      window.addEventListener('keypress', eventSubmit, true)
    } else {
      window.removeEventListener('keypress', eventSubmit, true)
    }
  },[eventSubmit, isOpened])

  useEffect(()=>{
    cbRef.current = handleSearch
  },[handleSearch])

  const renderDistribuidor = (): ReactNode => {
    const permissions = PermissionUtil.getPermissions()

    if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) && !PermissionUtil.isAdministrador(permissions) && contaUsuario?.data?.filiais?.length && contaUsuario?.data?.distribuidor?.id) {
      return (
        <InputComboBoxList
            filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
            key={`projetos-distribuidor`}
            options={[contaUsuario.data.distribuidor, ...contaUsuario.data.filiais]}
            label={"Distribuidor"}
            textField="nome"
            valueField="id"
            value={filters.distribuidor_id}
            renderOptions={(option: any) => {
                return `${option.nome} (${option.cnpj_cpf})`
            }}
            renderOptionsLabel={(option: any) => {
                return `${option.nome} (${option.cnpj_cpf})`
            }}
            onChange={(value: any) => {
                setDistribuidorState(value ? { ...value } : null);
                setFilters({distribuidor_id: value, revenda_id: null});
            }}
        />
      )
    }

    return (
        <InputComboBoxList
            filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
            key={`projetos-distribuidor`}
            options={distribuidoresList}
            label={"Distribuidor"}
            textField="nome"
            valueField="id"
            value={filters.distribuidor_id}
            renderOptions={(option: any) => {
                return `${option.nome} (${option.cnpj_cpf})`
            }}
            renderOptionsLabel={(option: any) => {
                return `${option.nome} (${option.cnpj_cpf})`
            }}
            onChange={(value: any) => {
                setDistribuidorState(value ? { ...value } : null);
                setFilters({distribuidor_id: value, revenda_id: null});
            }}
        />
    );
  }

  const getRevendas = useCallback(
    debounce((payload: string) => {
      setRevendasOptions([])

      if (!payload) return;

      const query = new URLSearchParams('')
      query.set('search', payload)
      setRevendasIsLoading(true)

      apiNoLoading.get({ url: `/cadastros/contas/revendas?${query.toString()}`}).then(response => {
        const items = response.data || []
        setRevendasOptions(items.map((item: any) => {
          return {
            id: item.id,
            nome: item.nome,
            cnpj_cpf: item.cnpj_cpf
          }
        }))
      }).finally(() => setRevendasIsLoading(false))
    }, 800),
    []
  );

  useEffect(()=>{
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_FILTRAR_REVENDA_SEM_DISTRIBUIDOR, permissoes)) return;
    getRevendas(searchRevendas)
  },[searchRevendas])

  const renderRevenda = (): ReactNode => {
    return (
        <>
          {distribuidorRevendaUsuario?.isRevenda ? (
            <InputComboBoxList
              key={`projetos-revenda`}
              filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
              options={[{ 
                id: distribuidorRevendaUsuario.revenda_id,
                nome: distribuidorRevendaUsuario.revenda_nome,
                cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf
              }]}
              label={"Revenda"}
              textField="nome"
              valueField="id"
              value={filters.revenda_id}
              renderOptions={(option: any) => {
                  return `${option.nome} (${option.cnpj_cpf})`
              }}
              renderOptionsLabel={(option: any) => {
                  return `${option.nome} (${option.cnpj_cpf})`
              }}
              onChange={(value: any) => {
                setFilters({ revenda_id: value });
              }}
            />
          ) : (
            <>
              {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_FILTRAR_REVENDA_SEM_DISTRIBUIDOR, permissoes) ? (
                <InputComboBoxList
                  key={`projetos-revenda`}
                  onInputChange={event => {
                    setSearchRevendas(event?.target?.value?.replace(/[^a-zA-Z0-9]/g, ""))
                  }}
                  options={revendasOptions}
                  filterOptions={(opts) => opts}
                  label={"Revenda"}
                  textField="nome"
                  valueField="id"
                  value={filters.revenda_id}
                  renderOptions={(option: any) => {
                      return `${option.nome} (${option.cnpj_cpf})`
                  }}
                  renderOptionsLabel={(option: any) => {
                      return `${option.nome} (${option.cnpj_cpf})`
                  }}
                  onChange={(value: any) => {
                    setFilters({ revenda_id: value });
                  }}
                  loadingText="Carregando..."
                  isLoading={revendasIsLoading}
                />
              ) : (
                <InputComboBox
                  key={`projetos-revenda`}
                  filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
                  path={distribuidorState ? `/cadastros/contas/revendas/${distribuidorState.id}` : ""}
                  label={"Revenda"}
                  provider={apiNoLoading}
                  textField="nome"
                  valueField="id"
                  value={filters.revenda_id}
                  renderOptions={(option: any) => {
                      return `${option.nome} (${option.cnpj_cpf})`
                  }}
                  renderOptionsLabel={(option: any) => {
                      return `${option.nome} (${option.cnpj_cpf})`
                  }}
                  onChange={(value: any) => {
                    setFilters({ revenda_id: value });
                  }}
                />
              )}
            </>
          )}
        </>
    )
}

  const maskNumber = useCallback((value: any)=>{
    let _value = value || "";
    _value = _value.replace(/\D/g, "");
    return _value;
  },[filters.numero_pedido, filters.n_nota_fiscal])

  const etapasVendaOptions = useMemo(()=>{
    const optionsToRemove = ["analise_financiamento"]
    return ETAPAS_LIST.filter(item => !optionsToRemove.includes(item.value) )
  },[])

  const tiposProjetosOptions = useMemo(()=>{
    const optionsToRemove = ["misto"]
    return TIPO_PROJETO.filter(item => !optionsToRemove.includes(item.value) )
  },[])

  return (
    <Drawer PaperProps={{ style: { width: 286 }}} anchor="right" open={isOpened} onClose={close}>
        <Box paddingLeft={'10px'} >
          <Button
              variant="text"
              color="primary"
              startIcon={<Close />}
              style={{marginTop: 10, marginBottom: 50}}
              onClick={close}
              >
              Fechar
          </Button>
        </Box>

        <Box flex={1} padding={2} alignItems='flex-start' display='flex' flexDirection={'column'}>
          <InputText
              label={"Código do projeto"}
              fullWidth={true}
              value={filters.codigo_projeto}
              onChange={(value: any) => {
                setFilters({codigo_projeto: value.target.value});
              }}
              />

          <InputText
              label={"Número do pedido"}
              fullWidth={true}
              value={maskNumber(filters.numero_pedido || '')}
              onChange={(value: any) => {
                setFilters({numero_pedido: value.target.value});
              }}
          />
          <InputText
              label={"Número da Nota Fiscal"}
              fullWidth={true}
              value={maskNumber(filters.n_nota_fiscal)}
              onChange={(value: any) => {
                setFilters({n_nota_fiscal: value.target.value});
              }}
          />
          <InputText
              label={"Título do projeto"}
              fullWidth={true}
              value={filters.titulo}
              onChange={(value: any) => {
                setFilters({titulo: value.target.value});
              }}
          />
          <InputText
              label={"Nome do Cliente"}
              fullWidth={true}
              value={filters.nome_cliente}
              onChange={(value: any) => {
                setFilters({nome_cliente: value.target.value});
              }}
          />
          <InputText
              label={"E-mail do cliente"}
              fullWidth={true}
              value={filters.email_cliente}
              onChange={(value: any) => {
                setFilters({email_cliente: value.target.value});
              }}
          />
          <InputText
            label={"CPF/CNPJ do cliente"}
            fullWidth
            value={filters.cpf_cliente}
            mask="cpf_cnpj"
            onChange={(value: any)=>{
              setFilters({cpf_cliente: value.target.value})
            }}
          />
          {/*<InputText
              label={"CPF/CNPJ do cliente"}
              fullWidth={true}
              value={Formater.toString(filters.cpf_cliente, TypeRecords.CPF_CNPJ)}
              InputProps={{
                inputComponent: CPFMask
            }}
              onChange={(value: any) => {
                setFilters({cpf_cliente: value.target.value});
              }}
            />*/}
          <InputText
              label={"Criado Por (nome do usuário)"}
              fullWidth={true}
              value={filters.criado_por}
              onChange={(value: any) => {
                setFilters({criado_por: value.target.value});
              }}
          />
 
          {renderDistribuidor()}

          {renderRevenda()}

          <InputComboBoxList
                multiple
                id={`list-etapas-vendas`}
                key={`list-etapas-vendas`}
                label={"Etapa de Venda"}
                textField="text"
                valueField="value"
                options={etapasVendaOptions}
                autoComplete
                value={filters.etapa_venda}
                onChange={(value: any[]) => {
                  setFilters({etapa_venda: value});
                }}
                renderOptions={(option: any) => {
                    return `${option.text}`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.text}`
                }}
            />

          <InputComboBoxList
              id={`list-situacao-pagamento`}
              key={`list-situacao-pagamento`}
              label={"Status de pagamento"}
              textField="text"
              valueField="value"
              options={SITUACAO_PAGAMENTOS_LIST}
              autoComplete
              value={filters.situacao}
              onChange={(value: any) => {
                setFilters({situacao: value || null});
              }}
              renderOptions={(option: any) => {
                  return `${option.text}`
              }}
              renderOptionsLabel={(option: any) => {
                  return `${option.text}`
              }}
          /> 

          {isAdmin && (
              <InputComboBoxList
                multiple
                id={`list-tipos-projetos`}
                key={`list-tipos-projetos`}
                label={"Tipos de Projetos"}
                textField="text"
                valueField="value"
                options={tiposProjetosOptions}
                autoComplete
                value={filters.tipo}
                onChange={(value: any[]) => {
                  setFilters({tipo: value});
                }}
                renderOptions={(option: any) => {
                    return `${option.text}`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.text}`
                }}
              />
            )}

        <InputComboBoxList
              id={`list-expirado`}
              key={`list-expirado`}
              label={"Projeto expirado?"}
              textField="text"
              valueField="value"
              options={EXPIRADO_LIST}
              autoComplete
              value={filters.projeto_expirado}
              onChange={(value: any[]) => {
                setFilters({projeto_expirado: value || null});
              }}
              renderOptions={(option: any) => {
                  return `${option.text}`
              }}
              renderOptionsLabel={(option: any) => {
                  return `${option.text}`
              }}
          />
          <InputComboBoxList
                id={`list-kits`}
                key={`list-kits`}
                label={"Projeto de Kits?"}
                textField="text"
                valueField="value"
                options={KITS_LIST}
                autoComplete
                value={filters.projeto_kits}
                onChange={(value: any[]) => {
                  setFilters({projeto_kits: value || null});
                }}
                renderOptions={(option: any) => {
                    return `${option.text}`
                }}
                renderOptionsLabel={(option: any) => {
                    return `${option.text}`
                }}
            />
            <InputComboBoxList
                  id={`list-segmento`}
                  key={`list-segmento`}
                  label={"Segmento"}
                  textField="text"
                  valueField="value"
                  options={SEGMENTO_LIST}
                  autoComplete
                  value={filters.segmentos}
                  onChange={(value: any) => {
                    setFilters({segmentos: value || null});
                  }}
                  renderOptions={(option: any) => {
                      return `${option.text}`
                  }}
                  renderOptionsLabel={(option: any) => {
                      return `${option.text}`
                  }}
              />

              {isAdmin && (
                <InputComboBoxList
                    id={`list-origem`}
                    key={`list-origem`}
                    label={"Origem"}
                    textField="text"
                    valueField="value"
                    options={ORIGEM_LIST}
                    autoComplete
                    value={filters.origem}
                    onChange={(value: any) => {
                      setFilters({origem: value || null});
                    }}
                    renderOptions={(option: any) => {
                        return `${option.text}`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.text}`
                    }}
                />
              )}
              {isAdmin && (
                <InputComboBoxList
                    id={`list-migrado`}
                    key={`list-migrado`}
                    label={"Projeto Migrado?"}
                    textField="text"
                    valueField="value"
                    options={PROJETO_MIGRADO}
                    autoComplete
                    value={filters.migrado}
                    onChange={(value: any) => {
                      setFilters({migrado: value || null});
                    }}
                    renderOptions={(option: any) => {
                        return `${option.text}`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.text}`
                    }}
                />
              )}
              <InputComboBoxList
                  id={`list-finame`}
                  key={`list-finame`}
                  label={"Projeto FINAME"}
                  textField="text"
                  valueField="value"
                  options={PROJETO_FINAME}
                  autoComplete
                  value={filters.finame || ''}
                  defaultValue={filters.finame || ''}
                  onChange={(value: any) => {
                    setFilters({finame: value || null});
                  }}
                  renderOptions={(option: any) => {
                      return `${option.text}`
                  }}
                  renderOptionsLabel={(option: any) => {
                      return `${option.text}`
                  }}
              />
        </Box>

        <Box height='75px' p={2} marginTop={'10px'} width={'100%'} display='flex' justifyContent={'flex-end'}>
          <Button onClick={() => setFilters(INITIAL_FILTERS_STATE)} style={{marginRight: '10px'}}  color="primary" variant="outlined">Limpar filtros</Button>
          <Button onClick={handleSearch} color="primary" variant="contained">Buscar</Button>
        </Box>

      </Drawer>
  )
}

export { FilterDrawer }
